import {
	type CommentCreateDto,
	postOrderIdComments,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getOrderCommentsByOrderIdQueryKey } from "Order/Api/Query/useOrderCommentsByOrderIdQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

export const useCreateCommentOrder = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: CommentCreateDto) => postOrderIdComments(data, orderId),
		onError: (error) => {
			console.error(`${t(orderMutationsResource.orderCommentError)}:`, error);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: getOrderCommentsByOrderIdQueryKey(orderId),
			});
			toast.success(t(orderMutationsResource.orderCommentSuccess));
		},
	});
};
